import React from "react"
import styled from "styled-components"
import SocialLinks from "../common/SocialLinks"
import { PageWidth, Eyebrow } from "components/common/Section"

const Container = styled(PageWidth)`
  border-top: 1px solid ${p => p.theme.border};
  padding: 64px 0 28px;
`
const Contact = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 64px;
  h2 {
    font-size: clamp(38px, 5vw, 60px);
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.05em;
    margin-top: 18px;
  }
`
const Signoff = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  border-top: 1px solid ${p => p.theme.border};
  padding-top: 24px;
  font-size: 11px;
  color: ${p => p.theme.muted};
  a {
    text-decoration: none;
  }
`
const Footer = () => (
  <Container>
    <Contact>
      <div>
        <Eyebrow>Say hello</Eyebrow>
        <h2>
          Get in touch<span aria-hidden="true"> ↗</span>
        </h2>
      </div>
      <SocialLinks size="17px" />
    </Contact>
    <Signoff>
      <span>Chaitanya Deorukhkar</span>
      <a href="#main-content">Back to top ↑</a>
    </Signoff>
  </Container>
)
export default Footer
